// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ({"89":"forum/components/ReportResourceModal","350":"forum/components/UploadResourceModal"}[chunkId] + ".js");